import { isEqual } from "./util"

import type { CompanyLocationAssociationOutput } from "@/graphql/codegen/graphql"

function allElementsSame<T>(array: T[]): boolean {
  if (array?.length === 0) return false
  const firstElement = array[0]

  const mapper =
    typeof firstElement === "object"
      ? (element: T) => isEqual(element, firstElement)
      : (element: T) => element === firstElement

  return array.every(mapper)
}

export function getConsolidatedValue<T, K extends keyof T>(items: T[], field: K): T[K] | null {
  if (!items || items.length === 0 || items.some((i) => i === undefined)) return null

  if (items.length === 1) {
    return items[0]?.[field] ?? null
  }

  const fields = items.filter((item) => item !== undefined && item !== null).map((item) => item[field])

  if (allElementsSame(fields)) {
    return fields[0]
  }

  return null
}

export function extractShippingViaCompanyId(associatedLocationList: CompanyLocationAssociationOutput[]): string | null {
  if (!associatedLocationList?.length) {
    return null
  }

  const ids = associatedLocationList.map(({ shippingVia }) => shippingVia?.companyId ?? null).filter(Boolean)

  return allElementsSame(ids) ? ids[0] : null
}
